import { Pagination } from "antd";
import "./style.css";

const itemRender = (_, type, originalElement) => {
  if (type === "prev") {
    return (
      <div className="prev-next-pagination">
        <i className="far fa-chevron-left va-1px" />
      </div>
    );
  }
  if (type === "next") {
    return (
      <div className="prev-next-pagination">
        <i className="far fa-chevron-right va-1px" />
      </div>
    );
  }
  return originalElement;
};

const PaginationContainer = ({
  total = 1,
  pageSize = 10,
  goTo = () => {},
  current,
  hideOnSinglePage = false,
  className,
}) => {
  return (
    <>
      <Pagination
        responsive
        className={className}
        current={current} // current page
        itemRender={itemRender}
        showSizeChanger={false}
        onChange={(e) => goTo(e)}
        pageSize={pageSize} // data per_page
        total={total} // max of iter_pages
        hideOnSinglePage={hideOnSinglePage}
      />
    </>
  );
};

export default PaginationContainer;
